module.exports = __webpack_public_path__ + "static/img/rule-tit.ef6bc838.png";